/**
 * Created by ShaunBetts on 14-May-16.
 */

import PortalError from 'module/error/PortalError';

const InvalidRequest = function(message, code) {
  this.data = new PortalError(message, code).data;
  this.data.type = 'InvalidRequest';
  this.data.typeLabel = 'Error making request';
};

InvalidRequest.prototype = Object.create(PortalError.prototype);

export default InvalidRequest;